import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Partner, PartnerPayload, PartnerState } from "./partnerInterfaces";
import {
  agreementFromPartnerId,
  partnerFromAgreementCode,
  themeFromAgreementCode,
  themeFromPartnerGroup,
} from "./partnerUtils";

import { allThemes } from "Components/Themes/allThemes";

const initialState: PartnerState = {
  partnerId: Partner.STOREBRAND,
  brandingTheme: allThemes.stb,
  agreementNumber: undefined,
  isUpdating: false,
  updated: false,
  error: null,
};

const partnerSlice = createSlice({
  name: "partner",
  initialState,
  reducers: {
    updateThemeFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload?.toString();
      state.isUpdating = false;
    },

    updateTheme: (state, action: PayloadAction<PartnerPayload>) => {
      const { payload } = action;

      state.isUpdating = true;
      state.brandingTheme = themeFromPartnerGroup(payload.brandingTheme);
      state.agreementNumber = agreementFromPartnerId(payload.partnerId);
      state.partnerId = payload.partnerId;
    },

    updateThemeFromAgreement: (
      state,
      action: PayloadAction<number | undefined>,
    ) => {
      state.isUpdating = true;
      state.brandingTheme = themeFromAgreementCode(action.payload);
      state.agreementNumber = action.payload;
      state.partnerId = partnerFromAgreementCode(action.payload);
    },

    updateThemeSucceeded: (state) => {
      state.isUpdating = false;
      state.updated = true;
    },
  },
});

export const {
  updateThemeFailed,
  updateTheme,
  updateThemeFromAgreement,
  updateThemeSucceeded,
} = partnerSlice.actions;

export const partner = partnerSlice.reducer;
